import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActions from '../auth/auth.actions';
import { tenantHelpers } from '../tenantInfo';
import './help.scss';

const version = process.env.VERSION;

export class HelpPageComponent extends Component {

  componentWillMount() {
    const { authActions } = this.props;
    const { fetchCurrentSession } = authActions;
    fetchCurrentSession();
  }

  render() {
    const { auth } = this.props;
    const { currentSession } = auth || {};
    const { session, user } = currentSession || {};
    const sessionType = session && session.type;
    const userId = user && user.id;

    const sessionInfo = sessionType ? [
      <li>
        User ID: {userId}
      </li>,
      <li>
        User Type: {sessionType}
      </li>
     ] : null;

    const productName = tenantHelpers.getProductName();

    return(
      <article className="help-page content">
        <h1 className="page-header">
          Help
        </h1>
        <p>
          DESCRIBE {productName}'S FUNCTION HERE.
          If you would like to download a copy of our help file please click the download button below.
        </p>
        <p>
          <a href="https://s3.amazonaws.com/arcaid-portal/help/ARCAID-Portal-Help.pdf" className="btn btn-default" download target="_blank">
            <span className="glyphicon glyphicon-download-alt" />
            Download Help File
          </a>
        </p>
        <hr />
        <h3>{productName} / Session Information</h3>
        <ul>
          <li>
            Version: {version}
          </li>
          {sessionInfo}
        </ul>
      </article>
    );
  }
}

HelpPageComponent.propTypes = {
};

const mapStateToProps = ({ auth }) => {
  return {
    auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpPageComponent);



// WEBPACK FOOTER //
// src/help/help-page.component.js